
import * as defaultImport from "uplot";
export * from "uplot";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
